import React, {useState, useEffect} from "react";
import {Field, useForm} from "react-final-form";
import states from "states-us";
import {required as requiredValidation} from "src/core/common/validations";
import AutoComplete from "src/core/common/components/elements/auto-complete/Input";
import Error from "src/core/common/components/elements/Error";
import {FieldContainer} from "src/core/common/components/collections/form/forms";
import {showErrorHighlight} from "src/core/common/utils";

const nonTerritoryUSStates = states
  .filter((state) => !state.territory && state.abbreviation !== "DC")
  .map((state) => ({
    label: state.name,
    value: state.abbreviation,
  }));

function StateSelect({
  name,
  placeholder,
  formatSelection = (entry) => entry.label,
  required,
  disabled,
  defaultState,
  onChange,
  styles,
}) {
  const form = useForm();
  const initialState =
    getStateByValue(defaultState) || getStateByValue(form.getState().initialValues[name]);
  const [searchState, setSearchState] = useState();

  useEffect(() => {
    setSearchState(initialState ? formatSelection(initialState) : "");
  }, [initialState]);

  return (
    <Field
      name={name}
      validate={required ? requiredValidation : undefined}
      render={({input, meta}) => (
        <FieldContainer>
          <AutoComplete
            disabled={disabled}
            onSelect={(entry) => {
              input.onChange(entry.value);
              onChange(entry.value);
              setSearchState(formatSelection(entry));
            }}
            onFocus={() => {
              input.onChange(undefined);
              onChange(undefined);
              setSearchState("");
            }}
            onChange={(search) => {
              input.onChange(undefined);
              onChange(undefined);
              setSearchState(search);
            }}
            placeholder={placeholder + (required ? "*" : "")}
            value={searchState}
            results={findStates(searchState)}
            resultsPosition={"top"}
            hasErrors={showErrorHighlight(meta)}
            styles={styles}
          />
          {meta.touched && <Error>{meta.error}</Error>}
        </FieldContainer>
      )}
    />
  );
}

function findStates(str) {
  if (!str) return nonTerritoryUSStates;
  return nonTerritoryUSStates
    .filter((state) => state.label.toLowerCase().indexOf(str.toLowerCase()) > -1)
    .slice(0, 5);
}

function getStateByValue(str) {
  if (!str) return null;
  return nonTerritoryUSStates.find(
    (state) => state.value.toLowerCase() === str.toLowerCase()
  );
}

export default StateSelect;
